module.exports = __webpack_public_path__ + "media/bgm.c1b029c9.mp3";